import { formatDateHuman, parseDateRaw } from "../date-utils";
export const qualityInternalMaintenanceDtoFields = [{
        name: "maintenanceDate",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(parseDateRaw(record.qualityInternalMaintenance.maintenanceDate))
    }, {
        name: "maintainer",
        title: "Manutentore",
        render: (record) => record.qualityInternalMaintenance.maintainer
    }];
